/**
 * Schemat do podpowiadacza edytora SQL — same nazwy tabel/widoków i kolumn (bez danych).
 *
 *   GET /settings/sql-schema                               — tenant (Ustawienia, pola SQL)
 *   GET /admin/global-dictionaries/sql-schema?tenantId=…   — ITE (słownik globalny, tenant z „Testuj")
 *
 * Cache 5 min: struktura bazy zmienia się rzadko (nowe pole/tabela dodatkowa). Jedno ponowienie
 * (pierwsze wywołanie na zimnym serwerze dev potrafi przekroczyć limit czasu klienta). Błąd pobrania
 * nie blokuje pola — edytor działa wtedy bez podpowiedzi tabel.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export type SqlSchemaNames = Record<string, string[]>;

const STALE_MS = 5 * 60 * 1000;

export const TENANT_SQL_SCHEMA_KEY = ['sql-schema', 'tenant'] as const;

export function useTenantSqlSchema(enabled = true): SqlSchemaNames | undefined {
  const query = useQuery({
    queryKey: TENANT_SQL_SCHEMA_KEY,
    queryFn: async () => {
      const res = await api.get<{ tables: SqlSchemaNames }>('/settings/sql-schema');
      return res.data.tables;
    },
    enabled,
    staleTime: STALE_MS,
    retry: 1,
  });
  return query.data;
}

export function useAdminTenantSqlSchema(
  tenantId: string | null | undefined,
): SqlSchemaNames | undefined {
  const query = useQuery({
    queryKey: ['sql-schema', 'admin', tenantId],
    queryFn: async () => {
      const res = await api.get<{ tables: SqlSchemaNames }>(
        '/admin/global-dictionaries/sql-schema',
        {
          params: { tenantId },
        },
      );
      return res.data.tables;
    },
    enabled: Boolean(tenantId),
    staleTime: STALE_MS,
    retry: 1,
  });
  return query.data;
}
